module.exports = __webpack_public_path__ + "static/img/ch1.81fb930.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント/ch1.png
// module id = 878
// module chunks = 1